import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/mdbvue.css'
import "@/assets/overrides.css"
import "@/assets/common.css"
import 'vue-datetime/dist/vue-datetime.css'
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import 'vue2-timepicker/dist/VueTimepicker.css'
import './filters'

import VueTimepicker from 'vue2-timepicker'
Vue.component('VueTimepicker', VueTimepicker)

import VueDatePicker from '@mathieustan/vue-datepicker';
Vue.use(VueDatePicker);

import Vue from "vue"
import { Datetime } from 'vue-datetime'

import ApiService from "@/services/api.service"

Vue.prototype.$http = ApiService;

Vue.component('date-picker', Datetime)
if (typeof window.moment === 'undefined'){
    window.moment = require("moment")
}

import MoneyFormat from "vue-money-format"
Vue.component('MoneyFormat', MoneyFormat)

import {
    mdbContainer,
    mdbRow,
    mdbIcon,
    mdbAlert,
    mdbCol,
    mdbJumbotron,
    mdbBtn,
    mdbCard,
    mdbInput,
    mdbListGroup,
    mdbListGroupItem,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
} from 'mdbvue';

Vue.component('mdb-btn', mdbBtn);
Vue.component('mdb-col', mdbCol);
Vue.component('mdb-row', mdbRow);
Vue.component('mdb-icon', mdbIcon);
Vue.component('mdb-card', mdbCard);
Vue.component('mdb-alert', mdbAlert);
Vue.component('mdb-input', mdbInput);
Vue.component('mdb-modal', mdbModal);
Vue.component('mdb-modal-header', mdbModalHeader);
Vue.component('mdb-modal-title', mdbModalTitle);
Vue.component('mdb-modal-body', mdbModalBody);
Vue.component('mdb-modal-footer', mdbModalFooter);
Vue.component('mdb-container', mdbContainer);
Vue.component('mdb-jumbotron', mdbJumbotron);
Vue.component('mdb-list-group', mdbListGroup);
Vue.component('mdb-list-group-item', mdbListGroupItem);



// WEBPACK FOOTER //
// ./src/components/globals/index.js